import OverviewIcon from '../../assets/OverviewIcon';
import CogIcon from '../../assets/CogIcon';
import { NavLink } from 'react-router-dom';
import './index.scss';
import { useDispatch } from 'react-redux';
import { toggleSidebar } from '../../reducers/User'

const Sidebar = (props) => {
	const dispatch = useDispatch();
	return(
		<div className="sidebar">
			<div className="sidebarHeader">
				<NavLink to="/" className="sidebarLogo">
					<img src="cleartax-logo-icon.png" /> GST PayLater
				</NavLink>
			</div>
			<div className="sidebarBody">
				<div className="sidebar_link">
					<NavLink to={`/dashboard${props.location?.search? props.location.search : ''}`} activeClassName="active">
						<OverviewIcon />
						Overview
					</NavLink>
				</div>
				<div className="sidebar_link">
					<NavLink to={`/profile${props.location?.search? props.location.search : ''}`} activeClassName="active">
						<CogIcon />
						Profile
					</NavLink>
				</div>
			</div>
			<div className="sidebarFooter">
				<button onClick={() => dispatch(toggleSidebar())}>
					<img src="ArrowCircleLeft.png" alt="arrow" />
				</button>
				<div className="finboxImg">
					<label>powered by</label>
					&nbsp;
					<img src="RupifiLogo.png" />
				</div>
				<div className="RupifySideImg">
					<img src="sideLogo.png" />
				</div>
			</div>
		</div>
	)
}

export default Sidebar;